import { AssetType } from '@takectrl-multiapp/svcs-share-config';
import { IBankingDetails } from './bank.interface';
import {  IScheduleInsuredAssets as IScheduleInsuredAssets } from './insured.interface';

export interface ISchedule {
  admin_fee: number;
  assistance_benefits?: Array<IAssistanceBenefits>;
  assistance_benefits_requested: boolean;
  banking_details: IBankingDetails;
  banking_details_id: number;
  commission: number;
  created_time: Date | null;
  ctrl_id: string;
  date_of_advice: Date;
  effective_date: Date;
  id: number;
  inception_date: Date;
  insurer_description: string;
  insurer_id: string;
  modified_time: Date | null;
  personal_liability: any;
  personal_liability_id: any;
  policy_id: string;
  policy_number: string;
  provider: string;
  quote_date: Date;
  quote_nr: string;
  quote_request_id: string;
  renewal_date: Date;
  sasria: number;
  status: string;
  total_premium: number;
  type: any;
  user_id: number;
   insured_assets?: IScheduleInsuredAssets;
}

export interface IAssistanceBenefits {
  description?: string;
  premium?: number;
  sum_insured?: number;
}
export interface IPremiumSummary {
  vehicle_liability: boolean;
  sub_total_premium: number;
  admin_fee: number;
  sasria: number;
  total_premium: number;
  broker_commission: number;
  claimPreparationCosts: number;
  renewal_period: Date;
}

export interface IEmergencyServices {
  road_side_assistance: number;
  route_help: number;
  safety_home_service: number;
  medical_emergency: number;
  emergency_home_help: number;
  legal_advice: number;
}

export interface IPersonalLiability {
  id?: number;
  claim_free_group?: any;
  premium?: number;
  sum_insured?: number;
  insured_amount?: number;
  effective_date?: Date;
  excess?: IPersonalLiabilityExcess;
}

export interface IPersonalLiabilityExcess {
  basic: number;
  basic_percentage: number;
}

export interface ISchedulesPremiumDetails {
  total_premium?: number;
  otherPremium?: number;
  contents_policies_count?: number;
  vehicle_policies_count?: number;
  motorcycle_policies_count?: number;
  caravan_policies_count?: number;
  buildings_policies_count?: number;
  all_risks_policies_count?: number;
  contents_premium?: number;
  vehicles_premium?: number;
  motorcycles_premium?: number;
  caravans_premium?: number;
  buildings_premium?: number;
  specified_items_premium?: number;
  all_risks_premium?: number;
  vaps_policies_count?: number;
  vaps_premium?: number;
}
